export const actionType = {
  PUT_MESSAGE: 'MESSAGES/ADD',
  REMOVE_MESSAGE: 'MESSAGES/REMOVE',
};
